<template lang="pug">
  .components-backoffice-parking-lot-zones(v-if="item")
    GoogleMapContainer
      google-map(v-if="mapCenter.lat !== 0 && mapCenter.lng !== 0", style="height:200px",
        ref="map",:searchBar="true",:mapTypeId="'roadmap'", :mapTypeControl="true" :api-key="mapsApiKey", :center="mapCenter" :zoom="12")
        div(v-if="item.allowed_zone")
          google-map-polygon(v-for="allowed in item.allowed_zone.poly", :positions="allowed", color="green", fillColor="green")
        div(v-if="item.forbidden_zone")
          google-map-polygon(v-if="item.forbidden_zone !== null", v-for="forbidden in item.forbidden_zone.poly", :positions="forbidden")
        div(v-if="item.undesiderable_zone")
          google-map-polygon(v-if="item.undesiderable_zone", v-for="undesiderable in item.undesiderable_zone.poly", :positions="undesiderable",  color="yellow", fillColor="yellow")
  loading-spinner(v-else)
</template>

<script>
  import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
  import GoogleMap from '../../../lib/map/GoogleMap'
  import GoogleMapPolygon from '../../../lib/map/GoogleMapPolygon'
  import LoadingSpinner from "../../structure/LoadingSpinner";
  import GoogleMapContainer from '../GoogleMapContainer'

  export default {
    name: "ParkingLotBoundaries",
    data() {
      return {
        item: null,
        mapsApiKey: window.env.GOOGLE_MAPS_KEY,
        mapCenter: {
          lat: 0,
          lng: 0,
        },
      }
    },
    components: {
      GoogleMapContainer,
      LoadingSpinner,
      GoogleMap,
      GoogleMapPolygon
    },

    created() {
      KeplerBackofficeSdk.configuration.get((data) => {
        this.mapCenter.lat = data.application.application_default_latitude.value
        this.mapCenter.lng = data.application.application_default_longitude.value
      })
      KeplerBackofficeSdk.parkingLots.select(this.$route.params.id).get((data) => {
        this.item = data
      })
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// ParkingLotZones.vue?037b5f12